import { type OrderManagementApi } from '@myorg/type-lib'
import api from '../../services/api' // 確保路徑正確
import { 
  API_ENDPOINTS,
  OrderQueryParams, 
  OrderHistoryResponse, 
  UpdateStatusPayload, 
  CheckoutResult, 
  CheckoutResult2, 
  CounterCheckoutPayload,
  OrderStatus,
} from '@myorg/type-lib'

/**
 * Order management API implementation
 */
export const orderManagementApi: OrderManagementApi = {
  getOrders: (): Promise<OrderHistoryResponse[]> =>
    api()
      .get(API_ENDPOINTS.ORDERS.ACTIVE)
      .then(r => r.data),

  updateItemStatus: (payload: UpdateStatusPayload): Promise<void> =>
    api()
      .patch(API_ENDPOINTS.ORDERS.ITEMS, {
        nextStatus: payload.newStatus,
        orderId: payload.orderId,
        itemId: payload.itemId,
      })
      .then(r => r.data),

  checkoutOrders: (
    orderIds: string[],
    extraInfo?: {
      memo2: string;
      status: OrderStatus;
      // 🟢 1. 在型別定義中，直接加入這三個發票欄位（設為選填 ?）
      carrier_num?: string;
      customer_identifier?: string;
      customer_name?: string;
    }
  ): Promise<CheckoutResult> =>
    api()
      .patch(API_ENDPOINTS.ORDERS.STATUS_UPDATE, { 
        ids: orderIds,
        memo2: extraInfo?.memo2,
        status: extraInfo?.status,
        // 🟢 2. 將前端傳進來的發票欄位，正式放入送給後端的 API Payload 中
        carrier_num: extraInfo?.carrier_num,
        customer_identifier: extraInfo?.customer_identifier,
        customer_name: extraInfo?.customer_name,
      })
      .then(r => r.data),
  
  // 💡 補上櫃台現場結帳的實作
  counterCheckoutOrders: (payload: CounterCheckoutPayload): Promise<CheckoutResult2> =>
    api()
      // 注意：後端 Go 是用 POST 喔！
      .post('/api/go-bff-service/payment/counter-checkout', { 
        ids: payload.ids,
        qr: payload.qr,
        carrier_num: payload.carrier_num,
        customer_identifier: payload.customer_identifier,
        customer_name: payload.customer_name,
        memo2: payload.memo2,
      })
      .then(r => r.data),

  // 💡 檢查重複交易的實作
  checkDuplicates: (payload: CounterCheckoutPayload): Promise<{ duplicates: string[] }> =>
    api()
      .post(API_ENDPOINTS.BFF.PAYMENT_CHECK_DUPLICATES, { 
        ids: payload.ids,
        qr: payload.qr,
        carrier_num: payload.carrier_num,
        customer_identifier: payload.customer_identifier,
        customer_name: payload.customer_name,
      })
      .then(r => r.data),
}